import window from 'window-or-global';
import { domBind, domUnbind } from '../../lib/dom-event';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';

// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

function stripInlineCommentMarker(editor, plugin, pasteObject) {
	if (pasteObject && pasteObject.node) {
		$('.inline-comment-marker', pasteObject.node).contents().unwrap();
	}
}

export default function () {
	bind('init.rte', () => {
		domUnbind(document, 'postPaste', stripInlineCommentMarker);
		domBind(document, 'postPaste', stripInlineCommentMarker);

		window.tinymce.activeEditor &&
			window.tinymce.activeEditor.on('Remove', () => {
				domUnbind(document, 'postPaste', stripInlineCommentMarker);
			});
	});
}
